import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import native from '@/utils/native';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'auth-redirect',
  setup(__props) {

const route = useRoute();

onMounted(() => {
  setTimeout(() => {
    native.method.authenticationDone(
      Reflect.get(route.query as any, 'type') || 'individual'
    );
  }, 500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "跳转中..."))
}
}

})